import React, { useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import AppActions from '../../actions/app-actions';
import { preformatWithRequestID } from '../../helpers';
import Form from '../common/forms/form';
import PasswordInput from '../common/forms/passwordinput'

const recaptchaSiteKey = '6LdeLf8ZAAAAAL7qBvWJuwmU384uS1y78DDnVo_f';

const passwordreset = () => {
  const [confirm, setConfirm] = useState(false);
  const [recaptcha, setRecaptcha] = useState('');

  const getCookie = (name) => {
    const cookies = new Cookies;
    const cookie = cookies.get(name);

    return cookie;
  }

  const removeCookie = (name) => {
    const cookies = new Cookies;
    cookies.remove(name);
  }

  const isCookieFound = (name) => {
    return (getCookie(name) ? true : false);
  }

  const handleSubmit = (formData) => {

    if (formData.password_new != formData.password_confirm) {
      AppActions.setSnackbar('Passwords you provided do not match, check again!', 5000, '');
      return;
    } else if (recaptchaSiteKey != '' && recaptcha === '') {
      AppActions.setSnackbar('Please complete the reCAPTCHA test before proceeding', 5000, '');
      return;
    }

    const email = getCookie('email');

    if (email) {
      AppActions.resetPassword({ email: email, password: formData.password_new, captchacode: recaptcha })
        .then(() => {
          setConfirm(true);
          removeCookie('email');
        })
        .catch(err => {
          var errMsg = 'Error';
          if (err.res.body && Object.keys(err.res.body).includes('error')) {
            errMsg = `${errMsg}: ${err.res.body['error']}`;
          }
          AppActions.setSnackbar(preformatWithRequestID(err.res, errMsg), null, 'Copy to clipboard');
        });
    }
  }

  return (
    <div className="full-screen">
      <div className="flexbox column" id="passwordReset-box">
        <img src="assets/img/1-edgeway_logo_rgb.png" alt="loginlogo.png" className="margin-bottom-small" id="passwordResetLogo" />
        <h1 className="align-center">Change your password</h1>
        {
          isCookieFound('email') ? (
            confirm ?
              (<p className="margin-bottom align-center">Password changed successfully.</p>) : (
                <>
                  <Form showButtons={true} buttonColor="primary" submitLabel="Submit" submitButtonId="submit_button" onSubmit={(formData) => handleSubmit(formData)} >
                    <PasswordInput
                      id="password_new"
                      label="New Password *"
                      create={true}
                      generate={false}
                      required={true} />

                    <PasswordInput
                      id="password_confirm"
                      label="Confirm Password *"
                      required={true} />

                    {
                      (recaptchaSiteKey) ? (
                        <div className="margin-top">
                          <ReCAPTCHA sitekey={recaptchaSiteKey} onChange={recaptcha => { setRecaptcha(recaptcha) }} />
                        </div>) : <span></span>
                    }
                  </Form>
                </>
              )
          ) : <p className="margin-bottom align-center">Invalid reset password link!</p>
        }
        <div className="margin-top-large text-muted">
          <div className="flexbox centered">
            <Link style={{ marginLeft: '4px' }} to="/login">
              Back to the login page
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default passwordreset;